import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

import EnhancedApp from "./components/EnhancedApp";

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <EnhancedApp />
    </StrictMode>
  );
}
